var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.749512 2.41911C0.749512 2.35467 0.80175 2.30243 0.866189 2.30243H11.1338C11.1982 2.30243 11.2505 2.35467 11.2505 2.41911V11.6366C11.2505 11.7011 11.1982 11.7533 11.1338 11.7533H0.866189C0.80175 11.7533 0.749512 11.7011 0.749512 11.6366L0.749512 2.41911ZM2.1016 3.64593C2.03716 3.64593 1.98492 3.69817 1.98492 3.76261V10.2931C1.98492 10.3576 2.03716 10.4098 2.1016 10.4098H9.8984C9.96284 10.4098 10.0151 10.3576 10.0151 10.2931V3.76261C10.0151 3.69817 9.96284 3.64593 9.8984 3.64593H2.1016Z",
    fill: "#585D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8014 5.30095L1.2005 5.30095L1.2005 2.90073L10.8014 2.90073L10.8014 5.30095Z",
    fill: "#585D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56873 0.501677L9.56873 3.50196L8.1686 3.50196L8.1686 0.501677L9.56873 0.501677Z",
    fill: "#585D66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90112 0.501677L3.90112 3.50196L2.50099 3.50196L2.50099 0.501677L3.90112 0.501677Z",
    fill: "#585D66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56873 0.501677L9.56873 2.00182L8.1686 2.00182L8.1686 0.501677L9.56873 0.501677Z",
    fill: "#585D66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90112 0.501677L3.90112 2.00182L2.50099 2.00182L2.50099 0.501677L3.90112 0.501677Z",
    fill: "#585D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.a67964e926d0791591f30f9d43240ddd.svg";
export { ForwardRef as ReactComponent };